<template>
 <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;">        
        <v-btn class="adminLibelleBtn" :to="{name:`Edit${itemTypeName}`,params:{itemid:item.id}}" flat :title="$t(`Admin.${itemTypeName}.List.Reach${itemTypeName}Tooltip`)" >
          <v-icon class="mr-2" v-text="iconScope" :title="iconTitle" />
          {{libelle}}
        </v-btn>        
      </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer';


@Component({
  name: 'AdminMapLayerListLine',   
   props: {  
     item:{
       type:AloDbMapLayer,
       required:true 
     },
     itemTypeName:String
  }
})
export default class AdminMapLayerListLine extends Vue {
  item!:AloDbMapLayer  
  itemTypeName!:string

  get iconScope()
  {
    return this.item.LAY_SCOPE == "ENS"?"mdi-domain":this.item.LAY_SCOPE == "MIS"?"mdi-rocket":this.item.LAY_SCOPE == "MIG"?"mdi-rocket-outline":"mdi-earth"
  }

  get enseignesById(){
    return this.$store.myGetters.enseignesById
  }

  get adminMissionsById(){
    return this.$store.myGetters.adminMissionsById
  }

  get missionGlobalsById(){
    return this.$store.myGetters.missionGlobalsById
  }


  get libelle(){
     return this.item.LAY_SCOPE == "MIS"?`${this.adminMissionsById[this.item.MIS_ID!]?.MIS_LIBELLE?.split('_')?.pop() ?? ''} - ${this.item.libelle ?? ''}`: (this.item.libelle ?? '')
  }

  get iconTitle(){
    return this.item.LAY_SCOPE == "ENS"?this.enseignesById[this.item.ENS_ID!]?.ENS_LIBELLE
          :this.item.LAY_SCOPE == "MIS"?this.adminMissionsById[this.item.MIS_ID!]?.MIS_LIBELLE
          :this.item.LAY_SCOPE == "MIG"?this.missionGlobalsById[this.item.MIG_ID!]?.MIG_LIBELLE
          :[...(this.item.MISSION_IDS?.map(id => this.adminMissionsById[id]?.MIS_LIBELLE) ?? []),...(this.item.MISSION_GLOBALE_IDS?.map(id => this.missionGlobalsById[id]?.MIG_LIBELLE) ?? [])]?.join(", ")
  }

}
</script>

<style>
  .adminLibelleBtn {
    flex:1 0 auto;    
    max-width: 95%;
    overflow-x: hidden; 
    justify-content:flex-start; 
  }
  .adminLibelleBtn .v-btn__content{
    justify-content:flex-start; 
  }
</style>